import moment from "moment";

export const getValidationFieldClasses = function(fieldList,errors,fieldName)
{
    var classes = [];

    classes.push('fg_'+fieldName);

    if(errors.has(fieldName))
        classes.push('has-danger');

    if(fieldList[fieldName] && fieldList[fieldName].touched && fieldList[fieldName].valid)
        classes.push('has-success');

    return classes.join(" ");
}

// "120", "120.00" and 120 are the same value (inputs get reformatted on blur), empty values are null
export const normalizeFormValue = function(val)
{
    if (val === undefined || val === null || val === '') {
        return null;
    }

    return (typeof val === 'string' && /^-?\d+(\.\d+)?$/.test(val)) ? parseFloat(val) : val;
}

/**
 * General sorting function for different data types.
 * @param {Array} data - Array of objects to sort.
 * @param {String} key - The key to sort by.
 * @param {String} type - Type of data (string, numeric, date).
 * @param {String} order - Sorting order ('asc' or 'desc').
 * @returns {Array} - Sorted array.
 */
export function sortData(data, key, type = "string", order = "asc") {
    return [...data].sort((a, b) => {
        let valA = a[key];
        let valB = b[key];

        if (type === "numeric" || type === "money") {
            valA = parseFloat(valA) || 0;
            valB = parseFloat(valB) || 0;
        } else if (type === "date") {
            valA = moment(valA, "DD.MM.YYYY");
            valB = moment(valB, "DD.MM.YYYY");
        } else if (type === "datetime") {
            valA = moment(valA, "DD.MM.YYYY HH:mm:ss");
            valB = moment(valB, "DD.MM.YYYY HH:mm:ss");
        } else if (type === 'order_index') {
            valA = parseFloat(a[key+"_order_index"]) || 0;
            valB = parseFloat(b[key+"_order_index"]) || 0;
        } else if (type === 'interval') {
            valA = valA.length === 0 ? '' : (key === 'shift_plan_intervals' ? valA[0]['plan_interval_type'] + valA[0]['from'] : valA[0]['work_interval_type'] + valA[0]['from']);
            valB = valB.length === 0 ? '' : (key === 'shift_plan_intervals' ? valB[0]['plan_interval_type'] + valB[0]['from']: valB[0]['work_interval_type'] + valB[0]['from']);
        } else {
            valA = valA ? String(valA).toLowerCase() : "";
            valB = valB ? String(valB).toLowerCase() : "";
        }

        let comparison = 0;
        if (type === "numeric" || type === "money" || type === 'order_index') {
            comparison = valA - valB;
        } else if(type === "date" || type === "datetime") {
            if (!valA.isValid() && !valB.isValid()) comparison = 0;
            else if (!valA.isValid()) comparison = -1;
            else if(!valB.isValid()) comparison = 1;
            else comparison = valA.diff(valB);
        } else {
            var collator = new Intl.Collator('sk-u-kc');
            comparison = collator.compare(valA, valB);
        }

        return order === "desc" ? -comparison : comparison;
    });
}

export function renderChartHtmlTooltip(tooltipModel, chartContext, footerHtml = '', filterLinesFunction = null) {
    let tooltipEl = document.getElementById('chartjs-tooltip');

    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip';
        document.body.appendChild(tooltipEl);
    }

    if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    let html = '';

    if (tooltipModel.title.length > 0) {
        html += `<div><strong>${tooltipModel.title[0]}</strong></div>`;
    }

    if (tooltipModel.body) {
        if(filterLinesFunction) {
            var bodyLines = tooltipModel.body.filter(filterLinesFunction).map(b => b.lines.join('<br>'));
        } else {
            var bodyLines = tooltipModel.body.map(b => b.lines.join('<br>'));
        }

        bodyLines.forEach(line => {
            html += `<div>${line}</div>`;
        });
    }

    if (footerHtml) {
        html += `<div class="tooltip-footer">${footerHtml}</div>`;
    }

    tooltipEl.innerHTML = html;

    const position = chartContext._chart.canvas.getBoundingClientRect();
    tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
    tooltipEl.style.opacity = 1;
}

// global vue formatters for formating floats to hours/money string format

function formatNumberDynamic(num, minDecimals = 0, maxDecimals = 0) {
    if (num == null || num === '') return '';

    const n = Number(num);
    if (Number.isNaN(n)) return '';

    const raw = n.toString();

    const rawDecimals = raw.includes('.')
        ? raw.split('.')[1].replace(/0+$/, '').length
        : 0;

    const decimals = Math.min(
        maxDecimals,
        Math.max(minDecimals, rawDecimals)
    );

    const s = decimals > 0 ? n.toFixed(decimals) : Math.round(n).toString();
    const [int, frac] = s.split('.');

    return int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        + (frac ? ',' + frac : '');
}

// currency has no default on purpose: it depends on the restaurant country, so a missing one must not silently become €
export function formatMoney(num, currency, minDecimals = 2, maxDecimals = 2) {
    if(typeof num === 'undefined') {
        num = 0;
    }

    currency = (currency || '').replace('&amp;', '&') // fix &amp;euro; double encoding in json encode of datagrid resource
                               .replace('&euro;', '€');

    const formatted = formatNumberDynamic(num, minDecimals, maxDecimals);
    if (formatted === '') return '';
    return currency ? formatted + ' ' + currency : formatted;
}

export function formatHours(num, minDecimals = 0, maxDecimals = 2) {
    const formatted = formatNumberDynamic(num, minDecimals, maxDecimals);
    if (formatted === '') return '';
    return formatted + ' h.';
}

export function formatDays(num) {
    const formatted = formatNumberDynamic(num, 0, 2);
    if (formatted === '') return '';
    return formatted + ' d.';
}

const MINUTES_PER_DAY = 1440;

/**
 * Prevedie čas "HH:mm" na počet minút od začiatku dňa (0 - 1439), "24:00" = 0.
 * @param {String} time
 * @returns {Number} - NaN, ak čas nie je (zatiaľ) vyplnený
 */
function timeToMinutes(time) {
    const match = /^(\d{1,2}):(\d{2})(:\d{2})?$/.exec(time || '');

    if (!match) return NaN;

    return (Number(match[1]) * 60 + Number(match[2])) % MINUTES_PER_DAY;
}

/**
 * Posunie minúty do rozsahu 0 - 1439 (cyklicky cez polnoc).
 * @param {Number} minutes
 * @returns {Number}
 */
function wrapMinutes(minutes) {
    return ((minutes % MINUTES_PER_DAY) + MINUTES_PER_DAY) % MINUTES_PER_DAY;
}

/**
 * Prevedie intervaly na { from, length } v minútach, nevyplnené intervaly vynechá.
 * Interval s to <= from prechádza cez polnoc (napr. 22:00 - 06:00).
 * @param {Array} intervals - pole objektov { from: 'HH:mm', to: 'HH:mm' }
 * @returns {Array}
 */
function intervalsToRanges(intervals) {
    return intervals
        .map((interval) => {
            const from = timeToMinutes(interval.from);
            const to = timeToMinutes(interval.to);

            return { from, length: wrapMinutes(to - from) || MINUTES_PER_DAY };
        })
        .filter((range) => !isNaN(range.from) && !isNaN(range.length));
}

/**
 * Zistí, kedy začína pracovný deň - začiatok intervalu, pred ktorým je najdlhšia pauza.
 * Pevná hranica (napr. "všetko pred 05:00 je po polnoci") nefunguje - ranná zmena
 * 03:30 - 14:00 by sa rozdelila tak, že časť od 03:30 by sa uložila na ďalší deň.
 * Pri rovnakej pauze vyhrá skorší začiatok od 05:00 (pôvodné správanie).
 * @param {Array} ranges - výstup z intervalsToRanges
 * @returns {Number} - minúty od polnoci
 */
function workDayStart(ranges) {
    const ordered = ranges
        .slice()
        .sort((a, b) => wrapMinutes(a.from - 300) - wrapMinutes(b.from - 300));

    let start = 0;
    let longestGap = -1;

    ordered.forEach((range) => {
        // pauza od konca najbližšieho predchádzajúceho intervalu (cyklicky)
        const gap = Math.min(...ranges.map((other) => wrapMinutes(range.from - other.from - other.length)));

        if (gap > longestGap) {
            longestGap = gap;
            start = range.from;
        }
    });

    return start;
}

/**
 * Zistí, či sa niektoré dva intervaly prekrývajú. Nezávisí od poradia riadkov.
 * @param {Array} intervals - pole objektov { from: 'HH:mm', to: 'HH:mm' }
 * @returns {Boolean}
 */
export function intervalsOverlap(intervals) {
    if (!intervals || intervals.length < 2) return false;

    const ranges = intervalsToRanges(intervals);

    // porovnávame každý s každým - validácia nesmie závisieť od poradia riadkov
    // (cyklicky: intervaly sa prekrývajú, ak jeden začína vo vnútri druhého)
    for (let i = 0; i < ranges.length - 1; i++) {
        for (let j = i + 1; j < ranges.length; j++) {
            if (wrapMinutes(ranges[j].from - ranges[i].from) < ranges[i].length
                || wrapMinutes(ranges[i].from - ranges[j].from) < ranges[j].length) {
                return true;
            }
        }
    }

    return false;
}

/**
 * Zoradí intervaly chronologicky od začiatku pracovného dňa (aj cez polnoc).
 * Backend podľa tohto poradia určuje, ktoré intervaly patria na nasledujúci deň.
 * @param {Array} intervals
 * @returns {Array} - nové zoradené pole
 */
export function sortIntervalsByFrom(intervals) {
    const start = workDayStart(intervalsToRanges(intervals));

    const position = (interval) => {
        const from = timeToMinutes(interval.from);

        return isNaN(from) ? Infinity : wrapMinutes(from - start);
    };

    return intervals.slice().sort((a, b) => {
        const positionA = position(a);
        const positionB = position(b);

        return positionA === positionB ? 0 : positionA - positionB;
    });
}

/**
 * Vyberie správny tvar z Laravel plural reťazca a doplní :count.
 * Napr. '{1} :count deň|[2,4] :count dni|[5,*] :count dní'
 * @param {String} template - reťazec s variantmi oddelenými '|'
 * @param {Number} count
 * @returns {String}
 */
export function pluralize(template, count) {
    if (!template) {
        return String(count);
    }

    const segments = template.split('|');

    for (let i = 0; i < segments.length; i++) {
        const match = segments[i].match(/^(?:\{(\S+)\}|\[(\S+),(\S+)\])\s*([\s\S]*)$/);

        if (!match) {
            continue;
        }

        if (match[1] !== undefined && parseInt(match[1], 10) === count) {
            return match[4].replace(':count', count);
        }

        if (match[2] !== undefined) {
            const from = parseInt(match[2], 10);
            const to = match[3] === '*' ? Infinity : parseInt(match[3], 10);

            if (count >= from && count <= to) {
                return match[4].replace(':count', count);
            }
        }
    }

    return segments[segments.length - 1]
        .replace(/^(?:\{\S+\}|\[\S+,\S+\])\s*/, '')
        .replace(':count', count);
}



// WEBPACK FOOTER //
// ./resources/assets/admin/js/utils.js